import React, { memo } from "react";
import { Stack, Button } from "@mui/material";

import { useAppSelector } from "../../../../store/hooks";
import { selectSellerCentral } from "../../../../features/productAnalyzer/productAnalyzer.selector";
import { Home } from "../../../../utils";

const SellerCentral: React.FC = () => {
  const { sellerCentral } = useAppSelector(selectSellerCentral);

  return (
    <Stack
      position={"relative"}
      padding={"4px 4px"}
      direction={"row"}
      rowGap={"4px"}
      columnGap={"4px"}
      flexWrap={"wrap"}
    >
      {sellerCentral &&
        Object.entries(sellerCentral).map(([key, value]) => {
          const title = key
            .split(/(?=[A-Z])/)
            .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
            .join(" ");
          return (
            <Button
              variant="contained"
              href={value}
              key={key}
              target={"_blank"}
            >
              {key === "home" ? <img src={Home} alt="icon" /> : title}
            </Button>
          );
        })}
    </Stack>
  );
};

export default memo(SellerCentral);
